import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MessageService, ConfirmationService } from 'primeng/api';
import { AdministradorService } from '../../../services/administrador.service';
import { HttpErrorResponse } from '@angular/common/http';
import { RedimirMedico } from 'src/app/models/redimir.interface';

@Component({
    selector: 'app-canje-medico-atender',
    templateUrl: './canje-medico-atender.component.html',
    styleUrls: ['./canje-medico-atender.component.scss'],
    providers: [ConfirmationService, MessageService]
})
export class CanjeMedicoAtenderComponent implements OnInit {
    idRedimir!: string;
    redeemForm: FormGroup;
    redimir!: RedimirMedico;
    archivoSeleccionado: File | null = null;
    showModal = false;
    modalTitle = '';
    modalMessage = '';
    accionPendiente: 'cancelar' | 'rechazar' | null = null;

    get redimirFrm() {
        return this.redeemForm.controls;
    }
    get cantidad(): number {
        return this.redimir.productos.reduce((accumulator, item) => accumulator + (item.m_puntos ? item.m_puntos : 0), 0);
    }
    constructor(private fb: FormBuilder,
        private administradorService: AdministradorService,
        private activedRoute: ActivatedRoute,
        private messageService: MessageService,
        private location: Location,
        private router: Router,
        private confirmationService: ConfirmationService) {

        this.idRedimir = this.activedRoute.snapshot.params['id'];
        this.redeemForm = this.createFormRedimir();
        this.obtenerInformacion(this.idRedimir);
    }

    ngOnInit(): void {
    }

    obtenerInformacion(id: string): void {
        this.administradorService.getRedimirMedicoAtender(id)
            .subscribe({
                next: (resp) => {
                    this.redimir = resp.datos; this.fullRedimirForm(resp.datos);
                    console.log(this.redimir.productos);
                    this.showSuccess(resp.mensaje)
                },
                error: (err: HttpErrorResponse) => { this.showError(err.error.message) }
            })
    }

    createFormRedimir(): FormGroup {
        return this.fb.group({
            cantidad: ['', [Validators.required, Validators.min(0)]],
            fechaFinal: ['', Validators.required],
            observacion: ['', Validators.required]
        });
    }

    rechazardoCanje(): void {
        if (this.redeemForm.valid) {
            const formData = new FormData();
            formData.append('fk_redimir', this.idRedimir);
            formData.append('fechaFinal', this.redeemForm.get('fechaFinal')?.value);
            formData.append('observacion', this.redeemForm.get('observacion')?.value);
            this.administradorService
                .setRedimirMedicoRechazar(formData)
                .subscribe({
                    next: (resp) => {
                        this.showSuccess(resp.mensaje);
                        this.location.back();
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err.error.message);
                    }
                })
        }
    }

    fullRedimirForm(redimir: RedimirMedico): void {
        this.redimirFrm['cantidad'].setValue(redimir.redimir);
    }

    onFileSelected(event: any): void {
        const file = event.target.files[0];
        if (file) {
            const maxSize = 5 * 1024 * 1024; // 5MB
            if (file.size > maxSize) {
                this.showError('El archivo es demasiado grande. El tamaño máximo permitido es 5MB.');
                event.target.value = '';
                this.archivoSeleccionado = null;
                return;
            }
            this.archivoSeleccionado = file;
        }
    }

    onCancel(): void {
        this.accionPendiente = 'cancelar';
        this.modalTitle = 'Confirmar Salir';
        this.modalMessage = '¿Está seguro que desea Salir?';
        this.showModal = true;
    }

    onReject(): void {
        if (this.formTieneContenido()) {
            this.accionPendiente = 'rechazar';
            this.modalTitle = 'Confirmar Rechazo';
            this.modalMessage = '¿Está seguro que desea rechazar este canje?';
            this.showModal = true;
        }
    }

    onSubmit(): void {
        if (this.redeemForm.valid && this.archivoSeleccionado) {
            const formData = new FormData();
            formData.append('fk_redimir', this.idRedimir);
            formData.append('redimir', this.redeemForm.get('cantidad')?.value);
            formData.append('fechaFinal', this.redeemForm.get('fechaFinal')?.value);
            formData.append('observacion', this.redeemForm.get('observacion')?.value);
            formData.append('documento', this.archivoSeleccionado);
            // Aquí puedes agregar la lógica para enviar el formData al servidor
            this.administradorService
                .setCanjeMedicoAceptar(formData)
                .subscribe({
                    next: (resp) => {
                        console.log(resp);
                        this.showSuccess(resp.mensaje);
                        this.location.back();
                    },
                    error: (err: HttpErrorResponse) => { console.log(err.error.message) }
                })


        }
    }

    confirmarAccion(): void {
        if (this.accionPendiente === 'cancelar') {
            this.location.back();
        } else if (this.accionPendiente === 'rechazar') {
            console.log('Formulario rechazado');
            this.rechazardoCanje();
        }
        this.closeModal();
    }

    cancelarAccion(): void {
        this.closeModal();
    }

    closeModal(): void {
        this.showModal = false;
        this.accionPendiente = null;
    }

    resetForm(): void {
        this.redeemForm.reset();
        this.archivoSeleccionado = null;
    }

    formTieneContenido(): boolean {
        return !this.redeemForm.pristine || this.archivoSeleccionado !== null;
    }

    showSuccess(mensaje: string): void {
        this.messageService.add({
            severity: 'success',
            summary: 'Éxito',
            detail: mensaje
        });
    }

    showError(mensaje: string): void {
        this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: mensaje
        });
    }
}
